import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import SmallSlidePanel from "../add_customer/SmallSlidePanel";

const LoadingButtons = ({ id, isLoadingButtons }) => {
  const controlsFirst = useAnimation();
  const controlsSecond = useAnimation();
  const controlsThird = useAnimation();

  useEffect(() => {
    if (isLoadingButtons) {
      controlsFirst.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0,
        },
      });

      controlsSecond.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.2,
        },
      });

      controlsThird.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.6,
        },
      });
    } else {
      controlsFirst.stop();
      controlsSecond.stop();
      controlsThird.stop();
    }
  }, [isLoadingButtons, controlsFirst, controlsSecond, controlsThird]);

  return (
    <SmallSlidePanel
      isOpen={isLoadingButtons}
      onClose={() => {}}
      width={384} // matches max-w-sm
      showCloseButton={false}
    >
      <div id={id} className="relative bg-white shadow-lg p-6 rounded-sm">
        <div className="flex items-center justify-center mt-10 mb-8">
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsFirst}
          />
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsSecond}
          />
          <motion.div
            className="bg-black w-2 h-2 rounded-full mx-2"
            animate={controlsThird}
          />
        </div>
      </div>
    </SmallSlidePanel>
  );
};

export default LoadingButtons;
